import React from 'react';
import { FiTarget, FiEye, FiShield } from 'react-icons/fi';
import './About.css';

const About = () => {
  return (
    <section className="about" id="about">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">About Us</span>
          <h2>Why <span className="gradient-text">Slink</span>?</h2>
          <p>We're building India's most trusted video dating & social earning platform.</p>
        </div>
        <div className="about-grid">
          <div className="about-card mission">
            <FiTarget className="about-icon" />
            <h3>Our Mission</h3>
            <p>
              To create meaningful connections through face-to-face video interactions 
              while empowering users to earn real money. We believe in authentic relationships 
              built on real conversations, not just swipes.
            </p>
          </div>
          <div className="about-card vision">
            <FiEye className="about-icon" />
            <h3>What Makes Us Different</h3>
            <p>
              Unlike other dating apps, Slink rewards you for your time. Every video call 
              you receive earns you money. Our level system ensures that active and genuine 
              users earn the most. Real people, real connections, real earnings.
            </p>
          </div>
          <div className="about-card trust">
            <FiShield className="about-icon" />
            <h3>Safety First</h3>
            <p>
              We use screenshot protection on video calls, profile verification, 
              and encrypted communications. Our moderation team ensures a safe 
              and respectful community for everyone.
            </p>
          </div>
        </div>
        <div className="about-stats">
          <div className="about-stat">
            <span className="about-stat-num">50K+</span>
            <span className="about-stat-label">Downloads</span>
          </div>
          <div className="about-stat">
            <span className="about-stat-num">₹10L+</span>
            <span className="about-stat-label">Paid to Users</span>
          </div>
          <div className="about-stat">
            <span className="about-stat-num">100K+</span>
            <span className="about-stat-label">Video Calls Made</span>
          </div>
          <div className="about-stat">
            <span className="about-stat-num">25+</span>
            <span className="about-stat-label">Indian States</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
